import {computed, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {LoginServices} from "../../../auth/login/services/login.service";
import {environment} from "../../../../environments/environment.development";
import {Autorizaciones, AutorizacionReq} from "../interfaces/autorizaciones-interface";

const apiVucUrl = environment.apiVucUrl

@Injectable({
    providedIn: 'root'
})
export class AutorizacionesService {
    private apiUrl = apiVucUrl + `api/v1.0/autorizaciones`;
    _autorizacionesPersona: WritableSignal<Autorizaciones[]> = signal([]);
    autorizacionesPersona = computed(() => this._autorizacionesPersona());
    tipoAutorizacion: WritableSignal<number[]> = signal([]);// esta variable obtiene el tipo de autorizacion 1=Titular, 2= Profesional
    constructor(private http: HttpClient, private loginServices: LoginServices) {
    }

    consultaAutorizaciones(uniqueIdUsuarioAutoriza: string,tipos:number[]) {
        let userSessionReq = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        let url = this.apiUrl + `/consulta/${uniqueIdUsuarioAutoriza}?tipos=${tipos}`;
        return this.http.post<Autorizaciones[]>(url, userSessionReq, {observe: 'response'});
    }

    procesarAutorizacion(autorizacion: AutorizacionReq) {
        autorizacion.session = {
            uniqueId: this.loginServices.session()?.perfil?.uniqueId,
            usuario: this.loginServices.session()?.perfil?.usuario,
            documento: this.loginServices.session()?.perfil?.documento,
            correo: this.loginServices.session()?.perfil?.correo
        };
        return this.http.post(this.apiUrl, autorizacion);
    }
}
